<template>
  <div class="order_list">
    <titleBar :title="title" :tabs="tab_cur"></titleBar>
    <div class="tabs">
      <span
        :class="{cur : tab_cur == index}"
        v-for="(item, index) in tabs"
        @click="select_tab(index)"
      >{{item}}</span>
    </div>
    <div class="empty" v-if="empty">
      <img src="../../assets/images/common/lesson_empty.png" />
      <h3>还没有任何订单哦～</h3>
      <p @click="go_select">前往选课</p>
    </div>
    <div v-else class="list" v-load_more="load_more_event">
      <div class="item" v-for="(item, index) in data" v-if="data">
        <div v-if="item.orderState == 3" class="order_status">
          <span class="font_color_b0b">订单编号：{{item.orderId}}</span>
          <span class="fr font_color_838">已取消</span>
        </div>
        <div v-else-if="item.orderState == 2" class="order_status">
          <span class="font_color_b0b">订单编号：{{item.orderId}}</span>
          <span class="fr">已支付</span>
        </div>
        <div v-else-if="item.orderState == 1" class="order_status">
          <span class="font_color_ff7">
            未支付的订单将在
            <time_count :time="item.expired" :index="index" @time_count_end="time_count_end(index)"></time_count>后取消
          </span>
          <span class="fr font_color_838">待支付</span>
        </div>
        <div v-for="(v, i) in item.productList" class="order_mes">
          <h3>{{v.courseName}}</h3>
          <span
            class="order_price"
            :class="[item.orderState == 1 ? 'font_color_ff7' : 'font_color_838']"
          >¥{{v.price/100}}</span>
          <p class="order_time">
            <span>{{v.startToEnd}}</span>
            <span v-if="v.weekdays && v.weekdays.split('、').length == 7">每天 {{v.dayTime}}</span>
            <span v-else-if="v.weekdays && v.weekdays.split('、').length > 3">每周{{v.dayTime}}</span>
            <span
              v-else-if="v.weekdays && v.weekdays.split('、').length <= 3"
            >每周{{v.weekdays}} {{v.dayTime}}</span>
          </p>
          <p class="order_teacher">
            <span>{{v.teacher}}</span>
            <span class="font_color_979">主讲</span>
          </p>
        </div>
        <div class="order_pay">
          合计:
          <span
            :class="[item.orderState == 1 ? 'font_color_ff7' : 'font_color_838']"
          >¥{{item.amount/100}}</span>
          <p
            v-if="item.orderState == 1 && !item.time_end"
            class="fr btn_pay"
            @click="pay_event(item.orderId,index)"
          >立即支付</p>
          <p v-if="item.orderState == 1 && item.time_end" class="fr btn_no_pay">立即支付</p>
          <p class="fr btn_detail" @click="detail_event(item.orderId)">订单详情</p>
        </div>
      </div>
    </div>
    <div v-if="load" class="load_item">
      <img src="../../assets/images/common/shu.gif" />
      <p>加载中...</p>
    </div>
    <p v-if="toast" class="toast">{{toast}}</p>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import lesson_loading from "@/components/common/lesson_loading.vue";
import titleBar from "@/components/common/titleBar.vue";
import time_count from "@/components/common/time_count.vue";
import "@/assets/js/directive";
export default {
  name: "",
  data() {
    return {
      title: "我的订单",
      tabs: { "0": "全部", "1": "待支付", "2": "已支付", "3": "已取消" },
      tab_cur: 0,
      toast: "",
      loadingLock: true,
      status: "loading",
      data: [],
      token: "",
      version: "",
      source: "",
      orderId: 0,
      lock: false,
      load: false,
      empty: false
    };
  },
  methods: {
    select_tab: function(index) {
      console.log(index);
      this.tab_cur = index;
      this.lock = false;
      this.load = true;
      this.data = [];
      this.orderId = 0;
      this.initData();
    },
    time_count_end: function(index) {
      let self = this;
      console.log(index);
      self.data[index].time_end = true;
      self.toast = "订单已取消";
      setTimeout(function() {
        self.toast = "";
      }, 2000);
    },
    initData: async function() {
      if (this.lock) return;
      let self = this;
      self.lock = true;
      const [resp] = await ajax.all([
        ajax.get("/parent/live/order-list", {
          params: {
            token: self.token,
            version: self.version,
            source: self.source,
            orderId: self.orderId,
            orderState: self.tab_cur
          }
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        self.loadingLock = false;
        self.lock = false;
        self.load = false;
        self.data = self.data.concat(resp.data.data);
        self.empty = self.data.length == 0 ? true : false;
        if (resp.data.data == 0) {
          self.lock = true;
        } else {
          self.orderId = self.data[self.data.length - 1].orderId;
        }
      } else {
        self.loadingLock = true;
        self.lock = false;
        self.load = false;
        self.status = "error";
      }
    },
    pay_event: function(orderId, index) {
      let productId = this.data[parseInt(index) + 1].productList[0].productId;
      let url =
        window.location.origin +
        "/#/lesson/pay_sucess?token=" +
        this.token +
        "&version=" +
        this.version +
        "&source=" +
        this.source +
        "&sourceId=" +
        productId +
        "&hideTitleBar=1";
      window.location =
        "hybird://method/payLiveCourse?orderId=" +
        orderId +
        "&successUrl=" +
        escape(url);
    },
    detail_event: function(orderId) {
      this.$router.push({
        path:
          "/lesson/order_detail?token=" +
          this.token +
          "&orderId=" +
          orderId +
          "&version=" +
          this.version +
          "&source=" +
          this.source
      });
    },
    load_more_event: function() {
      this.initData();
    },
    go_select: function() {
      window.location =
        "pfastcalculation://pfastcalculation.knowbox.cn/learningpark";
    }
  },
  components: {
    lesson_loading,
    titleBar,
    time_count
  },
  created: function() {
    let self = this;
    self.token = utils.getQueryString("token");
    self.version = utils.getQueryString("version");
    self.source = utils.getQueryString("source");
    self.initData();
  }
};
</script>

<style lang="scss" scoped>
.order_list {
  .tabs {
    position: fixed;
    top: 0.88rem;
    left: 0;
    display: flex;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    background: #fff;
    z-index: 99;
    span {
      position: relative;
      display: inline-block;
      flex: 1;
      font-family: PingFangSC-Medium;
      font-size: 0.32rem;
      color: #b0b2c0;
      text-align: center;
    }
    .cur {
      color: #56586a;
      &:after {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0.08rem;
        margin: auto;
        display: inline-block;
        content: "";
        width: 0.6rem;
        height: 0.08rem;
        background-color: #e7be84;
        border-radius: 4px;
        text-align: center;
      }
    }
  }
  .empty {
    margin-top: 4.1rem;
    text-align: center;
    img {
      margin: 0 auto;
      width: 3.15rem;
      height: 2.86rem;
    }
    h3 {
      margin-top: 0.5rem;
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      color: #b0b2c0;
    }
    p {
      margin: 1rem auto 0;
      width: 2.4rem;
      height: 0.88rem;
      line-height: 0.88rem;
      background: #e7be84;
      font-family: PingFangSC-Medium;
      font-size: 0.32rem;
      color: #ffffff;
      border-radius: 0.44rem;
    }
  }
  .list {
    margin-top: 2.28rem;
    margin-bottom: 0.3rem;
    padding: 0 0.3rem;
    .item {
      padding: 0 0.3rem;
      background: #fff;
      border-radius: 0.2rem;
      margin-top: 0.3rem;
      box-shadow: 0 0.05rem 0.08rem 0 rgba(196, 202, 216, 0.42);
      .order_status {
        height: 0.8rem;
        border-bottom: 1px solid #eee;
        span {
          display: inline-block;
          line-height: 0.8rem;
          font-family: PingFangSC-Medium;
        }
      }
      .order_mes {
        position: relative;
        border-bottom: 1px solid #eee;
        padding: 0.3rem 0 0.5rem;
        h3 {
          font-family: PingFangSC-Semibold;
          font-size: 0.34rem;
          color: #56586a;
          margin-right: 0.8rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .order_time {
          margin-top: 0.2rem;
          span {
            font-family: PingFangSC-Regular;
            font-size: 0.26rem;
            color: #9796a4;
            &:last-child {
              margin-left: 0.1rem;
            }
          }
        }
        .order_teacher {
          margin-top: 0.4rem;
          span {
            font-family: PingFangSC-Medium;
            font-size: 0.26rem;
            color: #56546c;
            &:last-child {
              margin-left: 0.13rem;
              font-family: PingFangSC-Regular;
              color: #9796a4;
            }
          }
        }
        .order_price {
          position: absolute;
          top: 0.35rem;
          right: 0;
          font-family: PingFangSC-Medium;
          font-size: 0.36rem;
          line-height: 0.27rem;
        }
      }
      .order_pay {
        height: 1rem;
        line-height: 1rem;
        font-family: PingFangSC-Semibold;
        font-size: 0.3rem;
        color: #56586a;
        span {
          margin-left: 0.2rem;
          font-size: 0.42rem;
        }
        p {
          margin-top: 0.2rem;
          width: 1.8rem;
          height: 0.6rem;
          line-height: 0.6rem;
          font-size: 0.3rem;
          border-radius: 0.3rem;
          text-align: center;
          font-family: PingFangSC-Semibold;
        }
        .btn_detail {
          background: #fff;
          color: #8387a0;
          border: 1px solid #b0b2c0;
        }
        .btn_pay {
          margin-left: 0.3rem;
          background: #f5833d;
          color: #fff;
          border: 1px solid #f5833d;
        }
        .btn_no_pay {
          margin-left: 0.3rem;
          background: #ddd;
          color: #fff;
          border: 1px solid #ddd;
        }
      }
    }
  }
  .toast {
    position: fixed;
    width: 3rem;
    height: 1.5rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    line-height: 1.5rem;
    text-align: center;
    color: #fff;
  }
  .load_item {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 4.2rem;
    height: 3.3rem;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 20px;
    z-index: 99;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    color: #ffffff;
    img {
      margin: 0.6rem 0 0.2rem;
      width: 1.28rem;
    }
  }
  .font_color_ff7 {
    color: #ff714c;
  }
  .font_color_565 {
    color: #56586a;
  }
  .font_color_565 {
    color: #56586a;
  }
  .font_color_979 {
    color: #9796a4;
  }
  .font_color_b0b {
    color: #b0b2c0;
  }
  .font_color_838 {
    color: #8387a0;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
}
</style>